import { useEffect, useState } from "react"
import { getTemporadaById, postTemporada, patchTemporada} from "../../services/TemporadasServices"
import { TemporadasFormContext } from "./TemporadasContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const TemporadasFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getTemporadaByIdData(id)
    }, [])

    const getTemporadaByIdData = async (id) => {
        let res = await getTemporadaById(id)
     
        if (res) setReport(res)
    }

    const postTemporadaData = async (body) => {
        const res = await postTemporada(body)
  
        if (res) navigate("/temporadas");
    }

    const patchTemporadaData = async (id, body) => {
        const res = await patchTemporada(id, body)

        if (res) navigate("/temporadas");
    }


    return <TemporadasFormContext.Provider value={{
        report,
        postTemporadaData,
        patchTemporadaData,
    }} >
        {children}
    </TemporadasFormContext.Provider>
}